import { useAccountStore } from '@/store';
import { useForbiddenPaths } from '../useForbiddenPaths/useForbiddenPaths';
import { useEffect } from 'react';
import { accountService } from '@/services';
import { FetchError, logToSentryOnFetchError } from '@/utils';

export const useFetchSummaryIfAuthorised = () => {
    const { updateSummary } = useAccountStore((state) => ({
        updateSummary: state.updateSummary,
    }));
    const { isAllowedToRequestAuthorizedData } = useForbiddenPaths();

    useEffect(() => {
        if (isAllowedToRequestAuthorizedData) {
            void (async () => {
                await accountService
                    .summary()
                    .then((summary) => updateSummary(summary))
                    .catch((err) => logToSentryOnFetchError(err as FetchError));
            })();
        }
    }, [isAllowedToRequestAuthorizedData, updateSummary]);
};
